<div class="mat-elevation-z1">
  <div class="filter" [ngClass]="{ 'sticky-filter-header': stickyFilterHeader }">
    <div *ngIf="filterMode === 'quick'" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field class="no-wrapper">
        <input
          matInput
          [(ngModel)]="filter"
          title="Filter"
          type="search"
          placeholder="Filter"
          (keyup)="applyFilter(filter)"
        />
        <mat-icon class="filter-icon" matPrefix>filter_alt</mat-icon>
        <button *ngIf="filter" mat-icon-button matSuffix type="button" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <span fxLayoutGap="10px">
        <ng-container *ngFor="let action of tableActions; let i = index">
          <button
            mat-stroked-button
            type="button"
            [disabled]="
              action.canDisable ? checkBoxStatus === checkedStatus.NONE || showSpinner : showSpinner
            "
            (click)="tableClickAction(action.type, i)"
          >
            <mat-icon *ngIf="showSpinner && actionIndex === i">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
            {{ action.label }}
          </button>
        </ng-container>
      </span>
    </div>
    <div
      *ngIf="filterMode === 'actions' && tableActions?.length"
      class="filter-actions-only"
      fxLayout="row"
      fxLayoutAlign="end center"
    >
      <span fxLayoutGap="10px">
        <ng-container *ngFor="let action of tableActions; let i = index">
          <button
            mat-stroked-button
            type="button"
            [disabled]="
              action.canDisable ? checkBoxStatus === checkedStatus.NONE || showSpinner : showSpinner
            "
            (click)="tableClickAction(action.type, i)"
          >
            <mat-icon *ngIf="showSpinner && actionIndex === i">
              <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
            {{ action.label }}
          </button>
        </ng-container>
      </span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column.value">
      <ng-container *ngIf="column.value === checkbox">
        <th class="column-header" mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="checkBoxStatus === checkedStatus.ALL"
            [indeterminate]="checkBoxStatus === checkedStatus.PARTIAL"
            (change)="toggleAllRowsSelected()"
          ></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            [(ngModel)]="row.selected"
            (change)="checkIndeterminateStatus()"
            (click)="$event.stopPropagation()"
          ></mat-checkbox>
        </td>
      </ng-container>
      <ng-container *ngIf="column.value === actions; else showColumns">
        <th
          mat-header-cell
          *matHeaderCellDef
          style="text-align: right; max-width: 150px"
          [ngClass]="filterMode === 'column' ? 'column-header-filter' : 'column-header'"
        >
          <ng-content select="[actionButton]"></ng-content>
          <ag-table-column-panel
            *ngIf="displayFilterColumns"
            [placeholder]="'Filter Column'"
            [tableGridColumns]="displayedColumns"
            (columnsChanged)="columnsChanged.emit($event)"
          ></ag-table-column-panel>
        </th>
        <td mat-cell *matCellDef="let row" style="text-align: right; white-space: nowrap">
          <ng-container
            [ngTemplateOutlet]="rowActionIcons"
            [ngTemplateOutletContext]="{
              $implicit: {
                data: row
              }
            }"
          ></ng-container>
          <!-- Content projection row actions -->
          <ng-container *ngIf="rowActions">
            <button
              mat-icon-button
              type="button"
              [matMenuTriggerFor]="menu"
              [disabled]="showSpinner"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <!-- Row actions -->
            <mat-menu #menu="matMenu">
              <ng-container *ngFor="let action of rowActions">
                <button mat-menu-item type="button" (click)="rowActionSelect(action.type, row)">
                  {{ action.label }}
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </td>
      </ng-container>
      <ng-template #showColumns>
        <th
          [hidden]="!column.display"
          [ngClass]="filterMode === 'column' ? 'column-header-filter' : 'column-header'"
          mat-header-cell
          *matHeaderCellDef
          style="white-space: nowrap"
        >
          <div>
            @if (sortable) {
              <span [mat-sort-header]="column.value">{{ column.label }}</span>
            } @else {
              <span>{{ column.label }}</span>
            }
            <div>
              <mat-form-field *ngIf="filterMode === 'column'" floatLabel="never">
                <input
                  matInput
                  [(ngModel)]="columnFilterValues[column.value]"
                  (keyup)="onColumnKeyup($event, column.value)"
                />
                <button
                  *ngIf="columnFilterValues[column.value]"
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="clearColumnFilter(column.value)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </th>
        <ng-container *matCellDef="let row">
          <td
            *ngIf="column.value !== actions"
            mat-cell
            [hidden]="!column.display"
            [matTooltip]="column.tooltip ? column.tooltip(row[column.value]) : null"
            [innerHTML]="row | cellDisplayFn: column | cellConvertArray | highlight: filter"
            [ngClass]="{ 'text-link': column.clickFn }"
            (click)="column.clickFn ? column.clickFn(row) : null"
          ></td>
        </ng-container>
      </ng-template>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: stickyColumnHeader"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columns"
      (click)="toggleRow(row)"
      [ngClass]="{ highlight: row.selected, pointer: multiSelect || rowSelection }"
    ></tr>
    <tr class="mat-row" *matNoDataRow>
      <td style="text-align: center" class="mat-cell" [attr.colspan]="columns.length">
        {{ noDataMessage }}
      </td>
    </tr>
  </table>
  <mat-paginator
    *ngIf="showPagination"
    [ngClass]="{ 'mat-paginator-sticky': stickyFooter }"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="pageSizeOptions"
    [length]="length"
    (page)="onPageEvent($event)"
    showFirstLastButtons
  ></mat-paginator>
</div>
